import { axiosInstance } from '@/http-common'

export async function deleteWirepasLocation(locationId: number | string): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.delete(`/api/v1/wirepas-locations/${locationId}`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function updateWirepasLocationGateways(locationId: number | string, gwIds: string[], locationType?: string | null): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.patch(`/api/v1/wirepas-locations/${locationId}/gateways`, { gwIds, locationType: locationType ?? null })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function deleteWirepasGateways(gwIds: string[], deleteHistory: boolean): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.delete('/api/v1/admin/wirepas-gateways', { data: { gwIds, deleteHistory } })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function deleteWirepasAnchors(addresses: string[]): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.delete('/api/v1/admin/wirepas-anchors', { data: { addresses } })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}
